import React from 'react';
import { graphql } from 'gatsby';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';

import DynamicComponent from '~/components/DynamicComponent';
import useStoryblok from '~/utils/storyblok-service';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';

import { StaticImage } from 'gatsby-plugin-image';

import FeaturesSlider from '~/components/Dynamic/FeaturesSlider';
import AccordionTwoColumns from '~/components/Dynamic/AccordionTwoColumns';
import CountUpStats from '~/components/Dynamic/CountUpStats';
import TwoColumns from '~/components/Dynamic/TwoColumns';
import LogoStrip from '~/components/Dynamic/LogoStrip';

const FeaturesPage = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;
  const hero = content?.hero[0];
  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      <section className="relative z-0 -mt-20 -mb-28 md:-mb-20 lg:-mb-0 overflow-hidden pt-28 md:pt-36">
        <div className="absolute inset-0 pointer-events-none">
          <StaticImage
            src={`../assets/images/hero-gradient.jpg`}
            loading="eager"
            alt="hero background"
            className="w-full h-full"
            objectFit="cover"
            placeholder="blurred"
          />
        </div>

        <div className="container relative z-10">
          <div className="relative z-10">
            <div className="xl:w-7/12">
              <TextCard blok={hero.textCard[0]} />
            </div>
          </div>
          <div className="relative pt-8 md:pt-0 md:-mt-8 lg:-mt-10 xl:-mt-16">
            <div className="absolute bottom-0 bg-white h-1/3" style={{ left: '-5000px', right: '-5000px' }} />
            <div className="relative flex md:-ml-6 ">
              <div className="flex-col items-end justify-end hidden w-5/12 md:flex md:pl-6">
                <div className="w-full">
                  <div className="aspect-w-433 aspect-h-357 ">
                    <Image blok={hero.leftImage} className="w-full h-full" imageClassName="w-full h-full object-contain" />
                  </div>
                </div>
              </div>
              <div className="w-full md:w-7/12">
                <div className="pb-8 md:pb-12 md:pl-3">
                  <div className="aspect-w-690 aspect-h-460">
                    <Image blok={hero.rightImage}  className="w-full h-full" imageClassName="w-full h-full object-contain"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {content.intro?.length > 0 && <DynamicComponent blok={content.intro[0]} />}
      {content.accordionSlider?.length > 0 && <FeaturesSlider blok={content.accordionSlider[0]} />}
      {content.twoColumnAccordionImage?.length > 0 && <AccordionTwoColumns blok={content.twoColumnAccordionImage[0]} />}
      {content.stats?.length > 0 && <CountUpStats blok={content.stats[0]} />}
      {content.twoColumns?.length > 0 && <TwoColumns blok={content.twoColumns[0]} />}
      {content.logoStrip?.length > 0 && <LogoStrip blok={content.logoStrip[0]} />}
      {content.visualContentSlider?.length > 0 && <DynamicComponent blok={content.visualContentSlider[0]} />}
    </Layout>
  );
};

export default FeaturesPage;

export const query = graphql`
  query featuresQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
